import { createStore } from "vuex";
import createPersistedState from "vuex-persistedstate";

const API_URL = process.env.VUE_APP_MANAGER_API_URL;
document.title = "Voyado Onsite Manager"

export default createStore({
  state: {
    title: "Home",
    apiURL: API_URL,
    loader: false,
    prevCompanyId: "",
    activeRoute: "",
    cognitoInfo: {},
    dashboardInfo: {},
    filterInfo: {},
    dashboardFilter: {},
    globalSearch: {
      value: "",
      matchMode: "contains", // You can adjust this based on your needs
    },
    routes: [
      { Name: "/", Value: "home" },
      { Name: "/site/list", Value: "sitelist" },
      { Name: "/site/create", Value: "sitecreate" },
      { Name: "/site/edit/:id", Value: "siteedit" },
      { Name: "/site/copy/:id", Value: "sitecopy" },
      { Name: "/deal/list", Value: "deallist" },
      { Name: "/deal/create", Value: "dealcreate" },
      { Name: "/deal/edit/:id", Value: "dealedit" },
      { Name: "/performance", Value: "performance" },
      { Name: "/myambassadors", Value: "myambassadors" },
      { Name: "/myfriends", Value: "myfriends" },
      { Name: "/relations", Value: "relations" },
      { Name: "/user/list", Value: "userlist" },
      { Name: "/user/create", Value: "usercreate" },
      { Name: "/user/edit/:id", Value: "useredit" },
      { Name: "/companies", Value: "companylist" },
      { Name: "/company/create", Value: "companycreate" },
      { Name: "/company/edit/:id", Value: "companyedit" },
      { Name: "/changelog/:id", Value: "changelog" },
      { Name: "/changelog/:id", Value: "changelog" },
      { Name: "/contact/list", Value: "contactlist" },
      { Name: "/errorsummary", Value: "errorsummary" },
      { Name: "/sitechangelog/:id", Value: "siteChangelog" },
      { Name: "/editdeal/:id", Value: "editdeal" },
      { Name: "/deals/deallist", Value: "managedeallist" },
      { Name: "/copydeal/:id", Value: "copydeal" },
      { Name: "/searchdeal/:id", Value: "dealsearch" },
      {
        Name: "/updatetranslation",
        Value: "updatetranslation",
      },
    ],
  },
  plugins: [
    createPersistedState({
      paths: ["cognitoInfo", "dashboardInfo", "filterInfo", "dashboardFilter"],
    }),
  ],
  getters: {
    GetRoutePath: (state) => (pathName) => {
      var routeObj = state.routes.filter(function (path) {
        if (path.Value == pathName) {
          return path.Name;
        }
      });
      if (routeObj.length > 0) {
        return routeObj[0].Name;
      }
    },
    getGlobalSearch: (state) => {
      return state.globalSearch;
    },
  },
  mutations: {
    setGlobalSearch(state, search) {
      state.globalSearch = search;
    },
    // showLoader(state) {
    //   state.loader += 1;
    // },
    // hideLoader(state) {
    //   if (state.loader > 0) state.loader -= 1;
    //   else state.loader = 0;
    // },
    replaceTitle(state, newtitle) {
      state.title = newtitle;
      document.title = "Voyado Onsite Manager - " + newtitle;
    },
    setCognitoInfo(state, info) {
      state.cognitoInfo = info;
    },
    resetCognitoInfo(state) {
      state.cognitoInfo = {};
    },
    replaceCompanyId(state, newid) {
      state.cognitoInfo.companyid = newid;
      state.prevCompanyId = newid;

      state.cognitoInfo.companylist.forEach((element) => {
        element.selected = false;
      });

      var _filtered = state.cognitoInfo.companylist.filter(
        (a) => a.value == newid
      )[0];
      _filtered.selected = true;
      state.cognitoInfo.companyname = _filtered.text;
    },
    resetDashbboardInfoData(state) {
      state.dashboardInfo.data = "";
    },
    setDashboardInfo(state, info) {
      state.dashboardInfo = info;
    },
    resetDashboardInfo(state) {
      state.dashboardInfo = {};
    },
    resetDashboardLastSync(state) {
      state.dashboardInfo.lastSync = null;
    },
    resetDashbboardFilter(state) {
      state.dashboardFilter = "";
    },
    setDashboardFilter(state, filter) {
      state.dashboardFilter = filter;
    },
    setGlobalFilter(state, text) {
      state.filterInfo.global = text;
    },
    resetDealFilter(state) {
      state.filterInfo = {};
    },
    removeGlobalFilter(state) {
      state.filterInfo.global = "";
    },
    setActiveRoute(state, value) {
      state.activeRoute = value;
    },
  },
});
